import axiosInstance from '../auth/axiosConfig';
import {
  DASHBOARD_REQUEST,
  DASHBOARD_SUCCESS,
  DASHBOARD_FAIL,
} from './types';
import { Dispatch } from 'redux';


export const kpisActions = (anioSeleccionado: number, establ_corr: number) => async (dispatch: Dispatch): Promise<boolean> => {

  dispatch({ type: DASHBOARD_REQUEST });

  try {
    const res = await axiosInstance.get(`${import.meta.env.VITE_CSRF_API_URL}/kpisActions?anioSeleccionado=${anioSeleccionado}&establ_corr=${establ_corr}`);

    if (res.status === 200) {
      if (res.data) {
        dispatch({
          type: DASHBOARD_SUCCESS,
          payload: res.data
        });
        return true;
      }

    } else {
      dispatch({ type: DASHBOARD_FAIL });
    }
    return false;
  } catch (err: any) {
    dispatch({
      type: DASHBOARD_FAIL,
      error: "Error en la solicitud:", err,
    });
    return false;
  }
};
